import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  SpcApiInspectionsGetRequest,
  SpcApiInspectionsInspectionIdContextPutRequest,
  SpcApiInspectionsInspectionIdDeleteRequest,
  SpcApiInspectionsInspectionIdGetRequest,
  SpcApiInspectionsInspectionIdRecordsPutRequest,
  SpcApiInspectionsInspectionIdSubmitPostRequest,
  SpcApiInspectionsPostRequest,
  SpcApiSpecificationsSpecificationIdGetRequest,
  SpecificationsGetRequestInspectionTypeEnum,
} from "@sizlcorp/sizl-api-document/dist/models";

import { SpcInstance } from "@/instance/axios";

export const inspections = createQueryKeys("inspections", {
  all: null,
  get: (params: SpcApiInspectionsGetRequest) => {
    // const queryParams = { ...params };
    const queryParams = {
      ...params,
      query: JSON.stringify({
        $and: params?.query as unknown[],
        inspectionType: {
          $ne: SpecificationsGetRequestInspectionTypeEnum.SUB_IN_PROCESS,
        },
      }),
      sort: params.sort?.length ? params.sort : "-id",
    }; // 검사 기준 조회 시 기본 정렬 표시

    return {
      queryKey: [queryParams, JSON.stringify(queryParams)],
      queryFn: () => SpcInstance.inspectionsGet(queryParams),
    };
  },
  detail: (params: SpcApiInspectionsInspectionIdGetRequest) => ({
    queryKey: [params.inspectionId],
    queryFn: () => SpcInstance.inspectionsInspectionIdGet(params),
  }),
  find: (params) => ({
    queryKey: [params],
    queryFn: () => SpcInstance.inspectionsFindPost(params),
  }),
});

export const InspectionMutations = {
  create: (req: SpcApiInspectionsPostRequest) =>
    SpcInstance.inspectionsPost(req),
  submit: (req: SpcApiInspectionsInspectionIdSubmitPostRequest) =>
    SpcInstance.inspectionsInspectionIdSubmitPost(req),
  update: (req: SpcApiInspectionsInspectionIdRecordsPutRequest) =>
    SpcInstance.inspectionsInspectionIdRecordsPut(req),
  delete: (req: SpcApiInspectionsInspectionIdDeleteRequest) =>
    SpcInstance.inspectionsInspectionIdDelete(req),
  contextUpdate: (req: SpcApiInspectionsInspectionIdContextPutRequest) =>
    SpcInstance.inspectionsInspectionIdContextPut(req),
};

export const inspectionSpecifications = createQueryKeys(
  "inspectionSpecifications",
  {
    detail: (params: SpcApiSpecificationsSpecificationIdGetRequest) => ({
      queryKey: ["inspectionSpecification", params.specificationId],
      queryFn: () => SpcInstance.specificationsSpecificationIdGet(params),
    }),
  },
);
